export const blockIconsAudioandvideoVideoCameraFrontNew = (
	<span className='material-symbols-outlined'>video_camera_front</span>
);
